import { render, staticRenderFns } from "./hotActivities.vue?vue&type=template&id=2af42490&scoped=true&"
import script from "./hotActivities.vue?vue&type=script&lang=js&"
export * from "./hotActivities.vue?vue&type=script&lang=js&"
import style0 from "./hotActivities.vue?vue&type=style&index=0&id=2af42490&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af42490",
  null
  
)

export default component.exports